export enum ServicesViewsStateType {
  DELIVERIES_TABLE_STATE = 'deliveries.table',
  DELIVERIES_MAP_STATE = 'deliveries.map',
  DELIVERIES_FORM_STATE = 'services.forms',
}
